// extracted by mini-css-extract-plugin
export default {"cls1":"e2jvCchmaqfQVVxLgDjb","cls2":"IQfw4DmVgXpIpA6urlZw e2jvCchmaqfQVVxLgDjb","bookingAppRedesign":"s6sHf5jNZlJQjHkfowiF"};